/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Legal_Birth_DateInputs */

const cs_property_legal_birth_date = /** @type {(inputs: Property_Legal_Birth_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datum narození`)
};

const en_property_legal_birth_date = /** @type {(inputs: Property_Legal_Birth_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Birth date`)
};

/**
* | output |
* | --- |
* | "Birth date" |
*
* @param {Property_Legal_Birth_DateInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_legal_birth_date = /** @type {((inputs?: Property_Legal_Birth_DateInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Legal_Birth_DateInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_legal_birth_date(inputs)
	return cs_property_legal_birth_date(inputs)
});